import { NgModule } from '@angular/core';

import { AuditModalDirective } from './audit-modal.directive';
import { AutoFocusDirective } from './auto-focus/auto-focus.directive';
import { ClassOnHoverDirective } from './class-on-hover.directive';
import { ConfirmationModalDirective } from './confirmation-modal.directive';
import { FiltersDirective } from './filters.directive';
import { HiddenContentDirective } from './hidden-content.directive';
import { IsAllowedByRoleDirective } from './is-allowed-by-role.directive';
import { IsAllowedDirective } from './is-allowed.directive';
import { ObserveResizeDirective } from './observe-size.directive';
import { ObserveIntersectionDirective } from './observe-visibility.directive';
import { ReportRedirectDirective } from './report-redirect.directive';
import { AnchorResourceUrlHelperDirective } from './resource-url-helper/anchor-resource-url-helper.directive';
import { ImageResourceUrlHelperDirective } from './resource-url-helper/image-resource-url-helper.directive';
import { SortKeyDirective } from './sort-nav/sort-key.directive';
import { SortNavDirective } from './sort-nav/sort-nav.directive';

const directives = [
  AnchorResourceUrlHelperDirective,
  ImageResourceUrlHelperDirective,
  AuditModalDirective,
  AutoFocusDirective,
  ClassOnHoverDirective,
  ConfirmationModalDirective,
  FiltersDirective,
  IsAllowedByRoleDirective,
  IsAllowedDirective,
  ObserveIntersectionDirective,
  ObserveResizeDirective,
  ReportRedirectDirective,
  SortKeyDirective,
  SortNavDirective,
  HiddenContentDirective,
];

@NgModule({
  declarations: directives,
  exports: [directives],
})
export class DirectivesModule {}
